export default __webpack_public_path__ + "static/media/14.ada400d2.png";